module.exports = __webpack_public_path__ + "static/media/naked-news-cams-654415a5.1bf35da9.jpg";